<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="title-chart">{{ title }}</span>
    </div>

    <div v-if="!data" class="empty-state">
      <p>Tidak ada data tersedia</p>
    </div>
    <div v-else class="ranking-list" :style="{ maxHeight: isFull ? '470px' : '175px' }">
      <div v-for="(item, index) in data" :key="index" class="ranking-item">
        <div class="ranking-info">
          <p class="ranking-name">{{ item.name }}</p>
        </div>
        <div class="ranking-count">
          <span class="count-label">{{ item.count }} Member</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JumlahMember',
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: null,
    },
    isFull: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../style.scss';

.title-chart {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
}

.ranking-list {
  display: flex;
  flex-direction: column;
  max-height: 410px;
  overflow-y: auto;
  gap: 16px;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  padding: 12px;
}

.ranking-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px 16px 16px;
  border-bottom: 1px solid #e5e5e5;
}

.ranking-info {
  .ranking-name {
    font-size: 14px;
    font-weight: 600;
    color: #444444;
  }

  .ranking-role {
    font-size: 14px;
    color: #444444;
    margin-bottom: 2px;
  }

  .ranking-npa {
    font-size: 14px;
    color: #798892;
  }
}

.ranking-count {
  text-align: right;
  display: flex;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 24px;
  padding: 2px 8px;

  .count-label {
    color: #2f318b;
    font-weight: 600;
  }
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}
</style>
